import { stepRegistry } from '@/modules/wizard/services/step-registry'
import type { StepLoader } from '@/modules/wizard/types/StepLoader'

class StepResolver {
  public resolve(stepId: string): StepLoader {
    const componentLoader = (stepRegistry as Record<string, StepLoader>)[stepId]

    if (!componentLoader) {
      throw new Error(`Step with ID '${stepId}' is not registered.`)
    }

    return componentLoader
  }
}

export default new StepResolver()
